import React from 'react';

const IconEye = props => {
  const { className } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path fill="none" d="M14.8653 7.60849C15.0679 7.89249 15.1693 8.03516 15.1693 8.24516C15.1693 8.45582 15.0679 8.59782 14.8653 8.88182C13.9546 10.1592 11.6286 12.9118 8.5026 12.9118C5.37594 12.9118 3.0506 10.1585 2.13994 8.88182C1.93727 8.59782 1.83594 8.45516 1.83594 8.24516C1.83594 8.03449 1.93727 7.89249 2.13994 7.60849C3.0506 6.33116 5.3766 3.57849 8.5026 3.57849C11.6293 3.57849 13.9546 6.33182 14.8653 7.60849Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill="none" d="M10.5 8.24518C10.5 7.71475 10.2893 7.20604 9.91421 6.83096C9.53914 6.45589 9.03043 6.24518 8.5 6.24518C7.96957 6.24518 7.46086 6.45589 7.08579 6.83096C6.71071 7.20604 6.5 7.71475 6.5 8.24518C6.5 8.77561 6.71071 9.28432 7.08579 9.65939C7.46086 10.0345 7.96957 10.2452 8.5 10.2452C9.03043 10.2452 9.53914 10.0345 9.91421 9.65939C10.2893 9.28432 10.5 8.77561 10.5 8.24518Z" stroke="#242424" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default IconEye;
